import { businessOutline, homeOutline, locationOutline, personCircleOutline } from 'ionicons/icons';

import { COUNTRIES, CURRENT_COUNTRY_ID } from '~constants/environment';

export const INFO_TITLE = {
  addreses: 'addreses',
  paymentMethod: 'paymentMethod',
  coupons: 'coupons'
};

export const ICON_ADDRESS = {
  home: homeOutline,
  couple: personCircleOutline,
  other: locationOutline,
  work: businessOutline
};

export const DISPATCH_METHODS = {
  IN_STORE: 'in_store',
  PJ_DELIVERY: 'pj_delivery'
};

export const DEFAULT_MAX_RESULTS = 3;

// the google map sdk accepts changes on layout only passing it as an object
export const CONTAINER_MAP_CONFIG = {
  position: 'relative',
  height: '250px'
};

export const MAP_ENABLED = {
  [COUNTRIES.cl]: false,
  [COUNTRIES.es]: false,
  [COUNTRIES.pt]: false,
  [COUNTRIES.pa]: true,
  [COUNTRIES.cr]: true,
  [COUNTRIES.gt]: true
};

export const MAP_SELECTION_ENABLED = MAP_ENABLED[CURRENT_COUNTRY_ID] || false;

export const DEFAULT_ZOOM = 17;

export const MAP_POSITIONS = {
  cl: { lat: -33.4378305, lng: -70.65044920000003 },
  es: { lat: 40.4167754, lng: -3.7037901999999576 },
  pt: { lat: 38.7223, lng: -9.1393 },
  pa: { lat: 8.9912471, lng: -79.5268591 },
  cr: { lat: 9.9235433, lng: -84.0899257 },
  gt: { lat: 14.628434, lng: -90.522713 }
};

export const INITIAL_MAP_POSITION = MAP_POSITIONS[CURRENT_COUNTRY_ID] || MAP_POSITIONS.cl;

export const COUNTRY_CONFIRM_FLOW = [COUNTRIES.gt];
